<script>
    import { onMount } from 'svelte'
    import AuthContainer from './AuthContainer.svelte'
    import CreateSubscription from '../components/CreateSubscription.svelte'
    import { tenantStore } from '../state/store'
    import { t } from '../i18n/i18n'
    import { querystring } from 'svelte-spa-router'
    import { PRICE_ID_DEVELOPMENT_BASIC, PRICE_ID_PROD_BASIC, PRICE_ID_DEVELOPMENT_PRO, PRICE_ID_PROD_PRO, PRICE_PRO, PRICE_BASIC } from '../helpers/constants';
    import PlanInfo from '../components/PlanInfo.svelte'

    $: selectedPlan = 'pro'

    onMount(() => {
      let params = new URLSearchParams($querystring)
      const email = atob(params.get('email'))
      const _id = atob(params.get('tenant'))
      const name = atob(params.get('name'))
      tenantStore.set({_id, email, name})
    })
  
  </script>
  
<style>

  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  h3 {
    margin: 2rem 0;
    text-align: center;
  }

  section {
    display: flex;
    align-items: center;
    margin: 2rem 0;
    gap: 2rem;
  }

  section span:first-child {
    margin-left: 0;
  }


  label, span {
    width: 100%;
  }

  label {
    padding: 1rem;
    cursor: pointer;
    background: var(--bg-grey);
    border-radius: var(--radius);
    text-align: center;
    display: block;
  }


  input[type="radio"] {
    display:none;
  }

  input[type="radio"]:checked + label {
    background: var(--light-blue);
    color: var(--white);
  }

</style>
  
<AuthContainer>
  <div>
    <h1>{$t.choose_plan}</h1>
    <p>{$t['Step']} 2</p>
  </div>

  <section>
    <span>
      <input type='radio' bind:group={selectedPlan} value={'basic'} id='basic'>
      <label for='basic' name='basic'> {$t.basic} </label>
    </span>
    <span>
      <input type='radio' bind:group={selectedPlan} value={'pro'} id='pro'>
      <label for='pro' name='pro'> {$t.pro} </label>
    </span>
  </section>

  {#if selectedPlan === 'pro'}
    <PlanInfo plan="pro" />
  {/if}

  {#if selectedPlan === 'basic'}
    <PlanInfo plan="basic" />
  {/if}

  {#if selectedPlan === 'basic' && process.env.NODE_ENV === 'development'}
    <CreateSubscription amount={PRICE_BASIC} plan={'basic'} priceId={PRICE_ID_DEVELOPMENT_BASIC} />
  {/if}
  {#if selectedPlan === 'basic' && process.env.NODE_ENV === 'production'}
    <CreateSubscription amount={PRICE_BASIC} plan={'basic'} priceId={PRICE_ID_PROD_BASIC} />
  {/if}
  {#if selectedPlan === 'pro' && process.env.NODE_ENV === 'development'}
    <CreateSubscription amount={PRICE_PRO} plan={'pro'} priceId={PRICE_ID_DEVELOPMENT_PRO} />
  {/if}
  {#if selectedPlan === 'pro' && process.env.NODE_ENV === 'production'}
    <CreateSubscription amount={PRICE_PRO} plan={'pro'} priceId={PRICE_ID_PROD_PRO} />
  {/if}
  <h3>{$t.free_trial}  {$t['No payment required']}!</h3>
</AuthContainer>
